module.exports = __webpack_public_path__ + "media/screenshots/billing_reference-17ab24c8.png";